import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-dark text-white py-10 px-4" data-id="element-300">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-301">
        <div className="flex flex-col items-center justify-center" data-id="element-302">
          <UsersIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-303" />
          <span className="text-3xl font-black mb-1" data-id="element-304">+500</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-305">
            docentes
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-306">
          <BookOpenIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-307" />
          <span className="text-3xl font-black mb-1" data-id="element-308">5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-309">
            Cuadernillos listos
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-310">
          <div className="flex text-yellow-400 mb-3" data-id="element-311">
            <StarIcon className="w-8 h-8 fill-current" data-id="element-312" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-313" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-314" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-315" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-316" />
          </div>
          <span className="text-3xl font-black mb-1" data-id="element-317">4.9/5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-318">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-319">
          <MapPinIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-320" />
          <span className="text-3xl font-black mb-1" data-id="element-321">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-322">
            Todo el país
            <br data-id="element-323" />
            secundaria 1° a 5°
          </span>
        </div>
      </div>
    </section>;
}